module.exports = __webpack_public_path__ + "img/desktop-headline.f7bbef4f.png";